(function () {
  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (main && src) {
          main.removeAttribute('srcset');
          main.src = src;
          main.alt = thumb.getAttribute('data-alt') || '';
        }
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  // Collection sort
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Auto-submit cart when quantity changes
  document.querySelectorAll('[data-cart-form] .qty input').forEach(function (input) {
    input.addEventListener('change', function () {
      input.closest('form').submit();
    });
  });

  // Sticky header shrink
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ===== Cart drawer, search overlay, sticky add-to-cart =====
  var drawer = document.querySelector('[data-drawer]');
  var searchbox = document.querySelector('[data-searchbox]');
  var isCartPage = document.body.classList.contains('template-cart');

  function fmt(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PKR';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = n; });
  }
  function renderCart(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-body]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    body.textContent = ''; foot.textContent = '';
    setCount(cart.item_count);
    if (!cart.items.length) {
      var empty = el('div', 'drawer__empty');
      empty.appendChild(el('p', null, 'Your cart is empty.'));
      var shop = el('a', 'btn btn--solid', 'Shop Faras'); shop.href = '/collections/all';
      empty.appendChild(shop); body.appendChild(empty); return;
    }
    cart.items.forEach(function (item, i) {
      var row = el('div', 'drawer__item');
      var img = el('div', 'drawer__img');
      if (item.image) { var im = document.createElement('img'); im.src = item.image; im.alt = ''; im.loading = 'lazy'; img.appendChild(im); }
      var info = el('div', 'drawer__info');
      var t = el('a', 'drawer__title', item.product_title); t.href = item.url; info.appendChild(t);
      if (item.variant_title && item.variant_title !== 'Default Title') info.appendChild(el('div', 'drawer__var', item.variant_title));
      info.appendChild(el('div', 'drawer__price', fmt(item.final_price)));
      var qty = el('div', 'qty qty--sm');
      var minus = el('button', null, '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Decrease quantity');
      var num = el('span', 'qty__n', String(item.quantity));
      var plus = el('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Increase quantity');
      minus.addEventListener('click', function () { changeLine(i + 1, item.quantity - 1); });
      plus.addEventListener('click', function () { changeLine(i + 1, item.quantity + 1); });
      qty.appendChild(minus); qty.appendChild(num); qty.appendChild(plus); info.appendChild(qty);
      var rm = el('button', 'drawer__rm', 'Remove'); rm.type = 'button';
      rm.addEventListener('click', function () { changeLine(i + 1, 0); });
      info.appendChild(rm);
      row.appendChild(img); row.appendChild(info); body.appendChild(row);
    });
    var sub = el('div', 'drawer__sub');
    sub.appendChild(el('span', null, 'Subtotal')); sub.appendChild(el('strong', null, fmt(cart.total_price)));
    foot.appendChild(sub);
    foot.appendChild(el('p', 'drawer__note', 'Delivery is calculated at checkout.'));
    var co = el('a', 'btn btn--solid btn--block', 'Checkout'); co.href = '/checkout'; foot.appendChild(co);
    var vc = el('a', 'drawer__link', 'View full cart'); vc.href = '/cart'; foot.appendChild(vc);
  }
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }
  function changeLine(line, quantity) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('no-scroll');
    var x = drawer.querySelector('.drawer__x'); if (x) x.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); document.documentElement.classList.remove('no-scroll');
    setTimeout(function () { drawer.hidden = true; }, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-drawer-close]')) closeDrawer(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-cart-open]');
      if (!a || isCartPage) return;
      e.preventDefault(); loadCart().then(openDrawer);
    });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1 || isCartPage) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return loadCart(); }).then(openDrawer)
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }
  if (searchbox) {
    var sInput = searchbox.querySelector('[data-search-input]');
    var sOut = searchbox.querySelector('[data-search-results]');
    var sTimer = null;
    var openSearch = function () { searchbox.hidden = false; requestAnimationFrame(function () { searchbox.classList.add('is-open'); }); document.documentElement.classList.add('no-scroll'); setTimeout(function () { sInput.focus(); }, 60); };
    var closeSearch = function () { searchbox.classList.remove('is-open'); document.documentElement.classList.remove('no-scroll'); setTimeout(function () { searchbox.hidden = true; }, 350); };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
      else if (e.target.closest('[data-search-close]')) closeSearch();
    });
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (q.length < 2) { sOut.textContent = ''; return; }
      sTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var list = (d.resources && d.resources.results && d.resources.results.products) || [];
            sOut.textContent = '';
            if (!list.length) { sOut.appendChild(el('p', 'searchbox__none', 'No products found.')); return; }
            list.forEach(function (p) {
              var a = el('a', 'searchbox__item'); a.href = p.url;
              if (p.image) { var im = document.createElement('img'); im.src = p.image; im.alt = ''; a.appendChild(im); }
              var tx = el('div'); tx.appendChild(el('div', 'searchbox__t', p.title)); tx.appendChild(el('div', 'searchbox__p', p.price ? fmt(Math.round(parseFloat(p.price) * 100)) : ''));
              a.appendChild(tx); sOut.appendChild(a);
            });
          }).catch(function () {});
      }, 220);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeDrawer();
    if (searchbox && !searchbox.hidden) { searchbox.classList.remove('is-open'); document.documentElement.classList.remove('no-scroll'); setTimeout(function () { searchbox.hidden = true; }, 350); }
  });

  // Sticky add-to-cart bar
  var sticky = document.querySelector('[data-sticky-atc]');
  var buyRow = document.querySelector('.product__buy');
  if (sticky && buyRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buyRow);
  }

  // Depth parallax (illusion layers)
  var pEls = document.querySelectorAll('.story__media img, .auth__media img');
  if (pEls.length && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var ticking = false;
    var par = function () {
      pEls.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var c = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        img.style.translate = '0 ' + (c * -40).toFixed(1) + 'px';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(par); } }, { passive: true });
    par();
  }

  // 3D tilt (pointer devices only)
  var canTilt = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
    !(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (false && canTilt) {
    var bindTilt = function (zone, target, max) {
      zone.addEventListener('pointermove', function (e) {
        var r = zone.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        target.style.setProperty('--ry', ((px - 0.5) * 2 * max).toFixed(2) + 'deg');
        target.style.setProperty('--rx', ((0.5 - py) * 2 * max).toFixed(2) + 'deg');
        target.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
        target.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      });
      zone.addEventListener('pointerleave', function () {
        target.style.removeProperty('--rx'); target.style.removeProperty('--ry');
      });
    };
    document.querySelectorAll('[data-tilt-zone]').forEach(function (zone) {
      var target = zone.querySelector('[data-tilt-target]');
      if (target) bindTilt(zone, target, 9);
    });
    document.querySelectorAll('.card__media, .product__main').forEach(function (el) { bindTilt(el, el, 8); });
  }

  // Scroll reveal
  var selectors = [
    '.section-head', '.card', '.values__item', '.story__media', '.story__text > *',
    '.notes__inner > *', '.notes__col', '.newsletter__inner', '.footer__top > *',
    '.product__gallery', '.product__info > *', '.page-hero > *', '.cart__item', '.cart__summary',
    '.contact__form', '.contact__aside', '.auth__media', '.auth__form > *', '.page > *', '.account > *'
  ];
  var els = document.querySelectorAll(selectors.join(','));
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window) || reduce) return;

  els.forEach(function (el) {
    var siblings = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(selectors.join(',')); }) : [el];
    var i = Math.max(0, siblings.indexOf(el));
    el.setAttribute('data-reveal', '');
    el.style.setProperty('--d', Math.min(i, 5) * 110 + 'ms');
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  els.forEach(function (el) { io.observe(el); });

  // Rotating store-info toast
  var toast = document.querySelector('[data-toast]');
  if (toast) {
    var msgs = (toast.getAttribute('data-notices') || '').split('||').filter(Boolean);
    var textEl = toast.querySelector('[data-toast-text]');
    var delay = (parseInt(toast.getAttribute('data-delay'), 10) || 5) * 1000;
    var idx = 0, closed = false;
    try { closed = sessionStorage.getItem('faras-toast-closed') === '1'; } catch (e) {}
    var show = function () {
      if (closed || !msgs.length) return;
      textEl.textContent = msgs[idx % msgs.length];
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-in'); });
      setTimeout(function () {
        toast.classList.remove('is-in');
        idx++;
        setTimeout(function () { if (!closed) show(); }, 1800);
      }, delay);
    };
    toast.querySelector('[data-toast-close]').addEventListener('click', function () {
      closed = true; toast.classList.remove('is-in');
      try { sessionStorage.setItem('faras-toast-closed', '1'); } catch (e) {}
    });
    setTimeout(show, 3500);
  }
})();
